
export function getLocation() {
    let latitude = 0;
    let longitude = 0;
    if (navigator.geolocation) {
        console.log(navigator.geolocation)
        navigator.geolocation.getCurrentPosition(function(position) {
                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;
                console.log("Latitude: " + latitude);
                console.log("Longitude: " + longitude);
            },
            function(error) {
                console.log("Error occurred. Error code: " + error.code);
            });
    } else {
        console.log("浏览器不支持定位")
    }
    return {
        latitude,
        longitude
    }
}
